import { render } from "./CompanyDetail.vue?vue&type=template&id=78c5e4d1"
import script from "./CompanyDetail.vue?vue&type=script&lang=js"
export * from "./CompanyDetail.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\fostcrm-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__